/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  PreviewSpendRuleRequestBody,
  PreviewSpendRuleRequestBody$Outbound,
  PreviewSpendRuleRequestBody$outboundSchema,
} from "../components/previewspendrulerequestbody.js";

export type PreviewSpendRuleSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type PreviewSpendRuleSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type PreviewSpendRuleSecurity = {
  option1?: PreviewSpendRuleSecurityOption1 | undefined;
  option2?: PreviewSpendRuleSecurityOption2 | undefined;
};

export type PreviewSpendRuleRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  previewSpendRuleRequestBody: PreviewSpendRuleRequestBody;
};

/** @internal */
export type PreviewSpendRuleSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const PreviewSpendRuleSecurityOption1$outboundSchema: z.ZodMiniType<
  PreviewSpendRuleSecurityOption1$Outbound,
  PreviewSpendRuleSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function previewSpendRuleSecurityOption1ToJSON(
  previewSpendRuleSecurityOption1: PreviewSpendRuleSecurityOption1,
): string {
  return JSON.stringify(
    PreviewSpendRuleSecurityOption1$outboundSchema.parse(
      previewSpendRuleSecurityOption1,
    ),
  );
}

/** @internal */
export type PreviewSpendRuleSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const PreviewSpendRuleSecurityOption2$outboundSchema: z.ZodMiniType<
  PreviewSpendRuleSecurityOption2$Outbound,
  PreviewSpendRuleSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function previewSpendRuleSecurityOption2ToJSON(
  previewSpendRuleSecurityOption2: PreviewSpendRuleSecurityOption2,
): string {
  return JSON.stringify(
    PreviewSpendRuleSecurityOption2$outboundSchema.parse(
      previewSpendRuleSecurityOption2,
    ),
  );
}

/** @internal */
export type PreviewSpendRuleSecurity$Outbound = {
  Option1?: PreviewSpendRuleSecurityOption1$Outbound | undefined;
  Option2?: PreviewSpendRuleSecurityOption2$Outbound | undefined;
};

/** @internal */
export const PreviewSpendRuleSecurity$outboundSchema: z.ZodMiniType<
  PreviewSpendRuleSecurity$Outbound,
  PreviewSpendRuleSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => PreviewSpendRuleSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => PreviewSpendRuleSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function previewSpendRuleSecurityToJSON(
  previewSpendRuleSecurity: PreviewSpendRuleSecurity,
): string {
  return JSON.stringify(
    PreviewSpendRuleSecurity$outboundSchema.parse(previewSpendRuleSecurity),
  );
}

/** @internal */
export type PreviewSpendRuleRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  PreviewSpendRuleRequestBody: PreviewSpendRuleRequestBody$Outbound;
};

/** @internal */
export const PreviewSpendRuleRequest$outboundSchema: z.ZodMiniType<
  PreviewSpendRuleRequest$Outbound,
  PreviewSpendRuleRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    previewSpendRuleRequestBody: PreviewSpendRuleRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      previewSpendRuleRequestBody: "PreviewSpendRuleRequestBody",
    });
  }),
);

export function previewSpendRuleRequestToJSON(
  previewSpendRuleRequest: PreviewSpendRuleRequest,
): string {
  return JSON.stringify(
    PreviewSpendRuleRequest$outboundSchema.parse(previewSpendRuleRequest),
  );
}
